import React, { Component } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import Switch from "react-switch";
import Select from 'react-select';

import MateriaHist from "./MateriaHist";

import { ConsultaMaterias, ConsultElectivas } from "../../../funciones/HistoricoFunction";
import { ConsultPeriodos } from '../../../funciones/OfertaFunction';

class EditHistorico extends Component {
    state = {
        text: {
            icono: "fa fa-spinner fa-spin",
            nombre: "Cargando, espera"
        },
        valorTe: { value: '', label: '- Selecciona un Tipo de Evaluación -' },
        TeDisp: [{ value: '', label: '- Cargando -' }],
        allperiodoSelect: {value:"", label: "- Periodos -"},
        allperiodos: [],
        materiasSem: [],
        allValorTe: [],
        electivas: [],
        allValorPeriodo: "",
        allValorNota: "",
        Literales: []
    }

    constructor (props) {
        super(props)
        ConsultaMaterias(this.props.est.id, this.props.datSemestre.SemestreId, (resp) => {
            if (resp.length === 0) {
                this.setState({
                    text: {
                        icono: "",
                        nombre: "La búsqueda no obtuvo resultados"
                    },
                })
            }else{
                this.setState({
                    materiasSem: resp[0],
                    TeDisp: resp[1],
                })
            }
        })

        ConsultElectivas (this.props.datSemestre.SemestreId, (resp) => {
            this.setState({
                electivas: resp
            })
        })

        ConsultPeriodos((resp) => {
            this.setState({
                allperiodos: resp
            })
        })
    }

    valorSelectTe = (valorTe) => {

        this.setState({
            allValorTe: valorTe,
            valorTe,
            openDelMat: false,
        });
    }

    valorPeriodo = (allperiodoSelect) => {
        this.setState({
            allperiodoSelect,
            allValorPeriodo: allperiodoSelect.value,
            openDelMat: false,
        })
    }

    te = () => {
        let { valorTe, TeDisp } = this.state;

        /* return (
            <Select
                title = "Selecciona un Tipo de Evaluación"
                isSearchable ={true}
                value={valorTe}
                onChange={this.valorSelectTe}
                options={ TeDisp }
            />
        ) */
    }

    materias = () => {
        let { materiasSem, text, allValorTe, allperiodoSelect, allValorNota, allperiodos, electivas, Literales } = this.state;
        
        if (materiasSem.length === 0) return (
            <tr><td colSpan={8} align="center"><i className={text.icono}></i> {text.nombre}</td></tr>
        )

        let num = 1
        let numero = () => { return num ++; }
        let cantMaterias = materiasSem.length;

        let ContentMat = [];

        for (let i in materiasSem) {
            let tipo = "CUANTITATIVO";
            if((materiasSem[i].cuantitativo) === 0) tipo = "CUALITATIVO"

            if(materiasSem[i].matHistorico.length > 0){
                ContentMat.push({
                    id: materiasSem[i].id,
                    codigo: materiasSem[i].codigo,
                    nombre: materiasSem[i].nombre,
                    Historico: materiasSem[i].matHistorico[0][0],
                    Tipo: tipo
                })
            }else{
                ContentMat.push({
                    id: materiasSem[i].id,
                    codigo: materiasSem[i].codigo,
                    nombre: materiasSem[i].nombre,
                    Historico: "",
                    Tipo: tipo
                })
            }
        }

        let sec = 0;
        return (
            ContentMat.map(option => {
                sec += 3000;

                return(
                    <MateriaHist
                        key={option.id}
                        sec = {sec}
                        allValorTe={allValorTe}
                        allValorPeriodo={allperiodoSelect}
                        allValorNota={allValorNota}
                        cantidad = {cantMaterias}
                        electivas = {electivas}
                        allperiodos = {allperiodos}
                        funcRestPeriodo = {()=> {
                            this.setState({
                                allperiodoSelect: {value:"", label: "- Periodos -"},
                            })
                        }}

                        /* literales = {Literales} */
                        num = { numero() }
                        datos={option} 
                        est= {this.props.est}
                        funcion = { () => {
                            ConsultaMaterias(this.props.est.id, this.props.datSemestre.SemestreId/* this.props.datSemestre.value */, (resp) => {
                                if (resp.length === 0) {
                                    this.setState({
                                        text: {
                                            icono: "",
                                            nombre: "La búsqueda no obtuvo resultados"
                                        },
                                    })
                                }else{
                                    this.setState({
                                        materiasSem: resp[0],
                                        TeDisp: resp[1],
                                    })
                                }
                            })
                        }}
                    />
                )
            })
        )
    }

    cambioR = () => {

    }

    selectAllPeriodos = () => (e) => {
        if  (e.target.value === "") return null;

        this.setState({
            /* allValorPeriodo: e.target.value.toUpperCase() */
            allValorPeriodo: this.state.allperiodoSelect
        })
    }

    selectAllNotas = () => (e) => {
        if  (e.target.value === "") return null;
        
        this.setState({
            allValorNota: e.target.value.toUpperCase()
        })
    }

    render() {
        let { est } = this.props
        let { allperiodos, allperiodoSelect } = this.state;
        const styles = {
            padding: 5, fontSize: 10
        }

        const customStyles = (base) => ({
            ...base,
            fontSize: 12,
        });

        let MainAyuda = (
            <Popover style={{overflowY:"auto", height:"70vh", overflowX:"hidden"}} title={<React.Fragment><i className="fa fa-question-circle-o"></i> <strong>Agregar Datos Históricos</strong></React.Fragment>} id="hist">
                <div align="justify">
                    En esta sección podrás agregar, actualizar o eliminar las asignaturas correspondientes al semestre que has seleccionado.
                </div>
                <div className="custom-mt-10" align ="justify">
                    En primer lugar debes seleccionar las agisnaturas que deseas agregar mediante el botón <Switch height={12} width={24} checked={false} onChange={this.cambioR}/>
                </div>
                <Row>
                    <Col md={2} className="custom-mt-10">
                        <Switch height={12} width={24} checked={false} onChange={this.cambioR}/>
                    </Col>
                    <Col md={10} className="custom-mt-10">
                        Indica que la asignatura no ha sido seleccionada
                    </Col>
                    <Col md={2} className="custom-mt-10">
                        <Switch height={12} width={24} checked={true} onChange={this.cambioR}/>
                    </Col>
                    <Col md={10} className="custom-mt-10">
                        Indica que la asignatura esta seleccionada <span style={{fontSize:10}}>(Por defecto su calificacion es <strong>0</strong> y su Tipo de Evaluacion es <strong>Presencial</strong>)</span>
                    </Col>
                </Row>
                <div className="custom-mt-10" align ="justify">
                    Luego de seleccionar la asignatura puedes cambiar individualmente los valores <strong className="custom-color" style={{fontSize:10}}>PERIODO, T-E (Tipo de Evaluación) NOTA</strong>
                </div>
                <div className="custom-mt-10" align ="justify">
                    También puedes aplicar los cambios a todas las asignaturas seleccionadas mediante la opción <span className="custom-alert-info" style={{fontSize:10}}><strong>APLICAR A TODOS</strong></span>
                </div>
                <div className="custom-mt-10" align ="justify">
                    Sabrás que las calificaciones fueron actualizadas mediante el icono de la derecha:
                </div>
                <Row>
                    <Col md={2} className="custom-mt-10" align="center">
                        <i className="fa fa-circle" style={{color:"#9A9A9A", fontSize:10}}></i>
                    </Col>
                    <Col md={10} className="custom-mt-10" align ="justify" style={{fontSize: 10}}>
                        Estado inicial del campo a actualizar
                    </Col>
                    <Col md={2} className="custom-mt-10" align="center">
                        <i className="fa fa-spinner fa-spin" style={{color:"#9A9A9A", fontSize:10}}></i>
                    </Col>
                    <Col md={10} className="custom-mt-10" align ="justify" style={{fontSize: 10}}>
                        Indica que el campo a actualizar esta siendo procesado <strong>(en este momento no cierres la ventana)</strong>
                    </Col>
                    <Col md={2} className="custom-mt-10" align="center">
                        <i className="fa fa-times" style={{color:"#A0555C", fontSize:10}}></i>
                    </Col>
                    <Col md={10} className="custom-mt-10" align ="justify" style={{fontSize: 10}}>
                        Indica que hubo un error en la actualización del campo y debes volver a intentarlo
                    </Col>
                    <Col md={2} className="custom-mt-10" align="center">
                        <i className="fa fa-check" style={{color:"#32704C", fontSize:10}}></i>
                    </Col>
                    <Col md={10} className="custom-mt-10" align ="justify" style={{fontSize: 10}}>
                        Indica que el campo ha sido actualizado correctamente
                    </Col>
                </Row>
                <div className="custom-mt-10" align ="justify">
                    Las asignaturas que no poseen un botón de seleccion <Switch height={12} width={24} checked={false} onChange={this.cambioR}/> no pueden ser agregadas al archivo histórico debido a que se encuentran inscritas en el periodo actual y el sistema las agregará automáticamente.
                </div>
                <div className="custom-mt-10">
                    <a className="custom-color" style={{fontSize:10, background:"#f5f5f5", borderRadius: "3px 3px", border: "1px solid #DDD", padding: 5}}>
                        VER HISTÓRICO DE ESTA MATERIA <i className="fa fa-chevron-down"></i>
                    </a>
                </div>
                <div className="custom-mt-10" align ="justify">
                    Las materias con mas de una calificación podrán distinguirse porque se encuentran dentro de esta opción donde pueden editarse de forma individual
                </div>
            </Popover>
        )


        return (
            <div>
                <Row>
                    <Col md={10}>
                        <div className="custom-alert-success">Datos del Estudiante</div>
                        <Row style={{padding: 10}}>
                            <Col md={7}>
                                <span className="text-danger" style={{fontSize:10}}>Nombres y Apellido: </span>
                                <span className="text-muted" style={{fontSize:10}}>{est.nombre}</span>
                            </Col>
                            <Col md={5} align="right">
                                <span className="text-danger" style={{fontSize:10}}>Cédula de Identidad: </span>
                                <span className="text-muted" style={{fontSize:10}}>{est.ci}</span>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={2} align="right">
                        <OverlayTrigger trigger="focus" placement="bottom" overlay={ MainAyuda }>
                            <button className="btn btn-warning" style={{borderWidth:1}} title="Ayuda"><i className="fa fa-question-circle-o"></i></button>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <div className="custom-alert-warning custom-mt-10">Datos Históricos</div>
                <div className="custom-mt-10" style={{overflowY:"auto", height:"55vh", overflowX:"hidden"}}>
                    <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td align="center" style={styles}></td>
                                    <td align="center" width="10%" style={styles}><strong>CÓDIGO</strong></td>
                                    <td width="35%" style={styles}><strong>MATERIA</strong></td>
                                    <td align="center" width="15%" style={styles}><strong>PERIODO</strong></td>
                                    <td align="center" width="20%" style={styles}><strong>T-E</strong></td>
                                    <td align="center" width="10%" style={styles}><strong>NOTA</strong></td>
                                    <td align="center" width="10%" style={styles}><strong>LETRAS</strong></td>
                                    <td align="center" style={styles}></td>
                                </tr>
                                <tr className="custom-alert-info">
                                    <td colSpan={3} align="right" style={{padding: 1}}>Aplicar a todos:</td>
                                    <td style={{padding: 1}}>
                                        <Select
                                            styles={{menu: customStyles}}
                                            isSearchable ={true}
                                            value={allperiodoSelect}
                                            onChange={this.valorPeriodo}
                                            options={allperiodos}
                                        />
                                        {/* <input className="form-control" onDoubleClick={this.selectAllPeriodos()} type="text" placeholder="Periodo" title="Para añadir el periodo a todas las asignaturas haz doble click en este campo"/> */}
                                    </td>
                                    <td style={{padding: 1}} title="Selecciona una opción para cambiar el tipo de evaluacion a todas las asignaturas">
                                        {this.te()}
                                    </td>
                                    <td style={{padding: 1}}>
                                        <input className="form-control" onDoubleClick={this.selectAllNotas()} type="text" placeholder="Calificación" title="Para añadir la misma calificación a todas las asignaturas haz doble click en este campo"/>
                                    </td>
                                    <td style={{padding: 1}}></td>
                                    <td style={{padding: 1}}></td>
                                </tr>
                                {this.materias()}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className="custom-mt-10 text-muted" style={{fontSize: 12}}>
                    Al presionar <Switch height={12} width={24} checked={false} onChange={this.cambioR}/> sobre algúna materia, automáticamente se agregará al archivo histórico
                </div>
            </div>
        );
    }
}
 
export default EditHistorico;


// WEBPACK FOOTER //
// ./src/views/Registros/HistoricoContent/EditHistorico.jsx